import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useStripe } from '@stripe/react-stripe-js';
import { Actions as PAYMENTACTIONS } from '../../store/actions/paymentActions';
import { Actions as AUTHENTICATION_ACTIONS } from '../../store/actions/authenticationActions';
import { Button } from '../ui/button';
import { Loader2, ShoppingCart } from 'lucide-react';
import { Alert, AlertDescription } from '../ui/alert';

const SubscribingUser = ({
  orderFormAccepted,
  validationSchema,
  setValidationError,
  loggingIn,
  paymentMethod,
  processing,
  createStripeCheckoutSession,
  bacsCheckoutSession,
  renewOrgSub,
  planUpgrade,
  contactSales,
}) => {
  const stripe = useStripe();
  const [planCheckoutError, setPlanCheckoutError] = useState(false);
  const [contactingSales, setContactingSales] = useState(false);

  useEffect(() => {
    async function redirectCheckout() {
      //redirect user to Checkout Page as soon as we get the sessionId from the response
      if (stripe && bacsCheckoutSession) await stripe.redirectToCheckout({ sessionId: bacsCheckoutSession.id });
    }
    redirectCheckout();
  }, [bacsCheckoutSession, stripe]);

  const handleSubmit = async () => {
    await validationSchema
      .validate({ orderFormAccepted: orderFormAccepted }, { abortEarly: false })
      .then(async () => {
        try {
          setPlanCheckoutError(false);
          loggingIn(true); // show the spinner
          await createStripeCheckoutSession(paymentMethod.value, planUpgrade || undefined); // Creates a Checkout Session
          loggingIn(false);
        } catch (error) {
          console.log('Payment Error', error);
          if (error?.code === 'plan_not_self_serve' || error?.response?.data?.error === 'plan_not_self_serve') {
            setPlanCheckoutError(true);
          }
          loggingIn(false);
        }
      })
      .catch((error) => {
        // Still need to validate
        loggingIn(false);
        setValidationError(error.inner);
      });
  };

  const handleContactSales = async () => {
    setContactingSales(true);
    try {
      await contactSales({
        planId: planUpgrade?.planId,
        fteBand: planUpgrade?.fteBand,
        fte: planUpgrade?.fte,
        message: 'Checkout unlock was unavailable; customer requested sales contact.',
      });
    } catch {
      // The action displays the backend error.
    } finally {
      setContactingSales(false);
    }
  };

  if (planCheckoutError) {
    return (
      <div className='space-y-3'>
        <Alert>
          <AlertDescription>
            This plan is not currently unlocked for self-serve Checkout. You can contact our sales team instead.
          </AlertDescription>
        </Alert>
        <Button className='w-full' variant='outline' loading={contactingSales} onClick={handleContactSales}>
          Contact sales
        </Button>
      </div>
    );
  }

  return (
    <div className={renewOrgSub && 'login-wrap'}>
      <Button
        size='lg'
        className='w-full'
        id='submit-billingDetails'
        style={{ color: 'white' }}
        disabled={processing ? true : false}
        onClick={() => handleSubmit()}>
        {processing ? <Loader2 size={16} strokeWidth={1.5} className="animate-spin" style={{ marginRight: 5 }} /> : <ShoppingCart size={16} strokeWidth={1.5} style={{ marginRight: 5 }} />}
        Go to checkout page
      </Button>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    bacsCheckoutSession: state.payment?.stripe?.intent?.subscription || state.payment?.stripe?.intent,
    processing: state.authentication.processing,
    planUpgrade: state.payment?.planUpgrade,
  };
};

const mapDispatchToProps = (dispatch) => ({
  createStripeCheckoutSession: (paymentMethod, options) =>
    dispatch(PAYMENTACTIONS.createStripeCheckoutSession(paymentMethod, options)),
  contactSales: (payload) => dispatch(PAYMENTACTIONS.contactSales(payload)),
  loggingIn: (saving) => dispatch(AUTHENTICATION_ACTIONS.loggingIn(saving)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SubscribingUser);
